import React from 'react'
import PropTypes from 'prop-types'
import Button from '../../../common/ui/Button'

const ClearFilterButton = ({ onClick }) => (
  <Button
    className     = "plain text clear x"
    role          = "button"
    clickHandler  = {onClick}
  >
    <i className="fas fa-times" />
  </Button>
)

ClearFilterButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default ClearFilterButton